/**
 * @desc 编辑
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(body: defs.omsFlow.MskuMapsRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/mskuMap/edit`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
